module.exports = __webpack_public_path__ + "img/special-icon.f601b5a2.png";